<template>
<div class="articleTGList padding-20 bgc box-shadow">
    <div class="actionBar">
        <div class="btnBox">
            <el-button type="primary" @click="handleAdd">发布</el-button>
            <el-button type="primary" @click="specialConfiguration" v-if="user.isofficalhost === 1">专题配置</el-button>
        </div>
        <div class="search">
            <el-select v-model="param.status" placeholder="请选择">
                <el-option v-for="item in typeList" :key="item.code" :label="item.name" :value="item.code">{{item.name}}</el-option>
            </el-select>
            <el-input v-model="param.articlename" placeholder="请输入文章标题关键词" class="shopName"></el-input>
            <el-button @click="serarchArticle" type="primary" plain>搜索</el-button>
        </div>
    </div>
     <el-table :data="tableData" style="width: 100%" min-width="1200px">
        <el-table-column prop="articlename" label="文章标题" width="456">
            <template slot-scope="scope">
                    <div class="imageText">
                        <img v-if="scope.row.coveratturlid" :src="scope.row.coveratturlid" :alt="scope.row.articlename" preview="">
                        <div class="imageText-summary" :style="scope.row.coveratturlid ? {} : { marginLeft: '110px' }">
                            <div class="textBox">
                                <div class="text">{{scope.row.articlename}}</div>
                            </div>
                        </div>
                    </div>
            </template>
        </el-table-column>
        <el-table-column prop="articletypename" class-name="tableItem" label="文章类型"></el-table-column>
        <el-table-column prop="datetime" class-name="tableItem" label="发布时间" width="150"></el-table-column>
        <el-table-column prop="viewcount" class-name="tableItem" label="浏览量"></el-table-column>
        <el-table-column prop="status" class-name="tableItem" label="文章状态">
            <template slot-scope="scope">
                <div :class='{"state30":scope.row.status === 30,"state1":scope.row.status === 1,"state11":scope.row.status === 11, "state0": scope.row.status === 0, "state10": scope.row.status === 10, "state31": scope.row.status === 31}'>
                    <span>·{{scope.row.statusName}}</span>
                    <el-tooltip class="item" effect="dark" :content="scope.row.state" placement="top" v-if="scope.row.stateCode === 2">
                        <i class="el-icon-info"></i>
                    </el-tooltip>
                </div>
            </template>
        </el-table-column>
        <el-table-column prop="action" align="right" label="操作">
            <template slot-scope="scope">
                <div class="tableItemRight">
                    <span v-if="scope.row.newsurl" @click="handleShowUrl(scope.row.newsurl)">浏览</span>
                    <span v-if="scope.row.newsurl"> | </span>
                    <span @click="handleEdit(scope.row.innerid)">
                        <template v-if="scope.row.status === 1">查看</template>  
                        <template v-else>编辑</template>
                    </span>
                    <span> | </span>
                    <span @click="handlesDelete(scope.row.innerid)">删除</span>
                </div>
            </template>
        </el-table-column>
    </el-table>
    <page ref='page' :total="total" @getList="_getlist"></page>
    <ChoiceSpecialModule ref="choiceSpecialModule" />
</div>
</template>

<script>
import Page from '@/base/page/page'
import Share from 'base/share/share'
import {promiseUrlToQRCode} from 'common/js/tools'
import {mapGetters, mapActions} from 'vuex'
import {findAllByContribution, deleteArticlebyInnerid, joinRecommend} from '@/api/imageText'
import ChoiceSpecialModule from './components/choiceSpecialModule'
export default {
    name: 'articleTGList',
    data() {
        return {
            param: {
                articlename: '',
                status: ''
            },
            page: '',
            total: 0,
            typeList: [
                {code: '', name: '全部文章'},
                {code: '0', name: '草稿'},
                {code: '1', name: '待审核'},
                {code: '30', name: '审核成功'},
                {code: '11', name: '审核失败'}
            ],
            tableData: []
        }
    },
    created() {
    },
    mounted() {
        this._getlist()
    },
    beforeRouteEnter (to, from, next) {
        next(v => {
            if (v.$route.query.refresh === '1') {
                let page = {
                    page: 1,
                    pageSize: 10
                }
                v.setPage(page)
                v.$refs.page.pagination.page = 1
                v._getlist()
            } else if (v.$route.query.refresh === '0') {
                v._getlist()
            }
        })
    },
    methods: {
        specialConfiguration() {
            this.$refs.choiceSpecialModule.open()
        },
        handleAdd() {
            if (this.shop.authstatus === 0) {
                this.$confirm('该功能需要在开通企业版或者单独工具基础上方可使用，建议尽快购买，购买后可继续使用该功能', '提示', {
                    confirmButtonText: '去购买',
                    cancelButtonText: '取消'
                }).then(() => {
                    // 去购买
                    this.$router.push({name: 'OrderService'})
                    // this.$router.push({name: 'OrderService', query: {tabs: 'functionalService'}})
                }).catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '取消'
                    // })
                })
            } else {
                this.$router.push({name: 'ArticleTGEdit'})
            }
        },
        // 获取列表数据
        _getlist() {
            this.setLoading(true)
            // this.page = this.$refs.page.page
            findAllByContribution({
                data: Object.assign({}, this.param, this.$refs.page.page),
                success: data => {
                    this.setLoading(false)
                    data.data.content.forEach(obj => {
                        promiseUrlToQRCode(obj.shareurl, obj.coveratturlid).then(
                            function(data) {
                                obj.subject = obj.articlename
                                obj.qrShare = data
                            },
                            function(reason, data) {
                                console.log('二维码生成失败：', reason)
                            }
                        )
                    })
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        handleCommand(command) {
            this.state = command.name
            this.param.status = command.code
        },
        // 删除
        handlesDelete(innerid) {
            this.$confirm('确定将该文章删除吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                this.setLoading(true)
                deleteArticlebyInnerid({
                    data: {innerid: innerid},
                    success: data => {
                        this.setLoading(false)
                        if (data.code === '000') {
                            this.$message({
                                message: '删除成功',
                                type: 'success'
                            })
                            this._getlist(this.$refs.page.page.page)
                        }
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            }).catch(() => {})
        },
     
        // 编辑
        handleEdit(innerid) {
            this.$router.push({name: 'ArticleTGEdit', query: {innerid}})
        },
        //打开资讯链接
        handleShowUrl(url) {
            window.open(url, '_blank')
        },
        // 搜索图文
        serarchArticle() {
            this.setLoading(true)
            findAllByContribution({
                data: Object.assign({}, this.param, this.$refs.page.page),
                success: data => {
                    this.setLoading(false)
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                },
                error: data => {
                    this.setLoading(true)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setPage'
        ])
    },
    filters: {
    },
    watch: {},
    computed: {
        ...mapGetters([
            'loading',
            'user',
            'permission',
            'shop'
        ])
    },
    components: {
        Page, Share, ChoiceSpecialModule
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
@import "~common/scss/base";
.articleTGList {
    box-sizing: border-box;
    .actionBar{
        @include flexBox(space-between);
        margin-bottom: 42px;
        .search{
            @include flexBox(space-around);
            .el-select{
                position: relative;
                top: 2px;
                .el-input{
                    height: 36px;
                    .el-input__inner{
                        height: 36px;
                    }
                }
            }
            .shopName{
                box-sizing: border-box;
                margin: 0 20px 0 20px;
                width: 240px;
                .el-input__inner{
                    width: 240px;
                    height: 36px;
                }
            }
            .el-button{
                width: 96px;
                height: 36px;
                margin-top: 5px;
            }
        }
    }
    .el-table{
        min-width: 1000px;
    }
    .tableItem{
        text-align: center;
    }
    .tableItemRight{
        text-align: right;
        color: #409EFF;
        .actionBtn{
            display: flex;
            align-items: center;            
        }
        span{
            cursor: pointer;
            font-size: 12px;
            margin-left: 10px;
        }
    }
    .state30{
        color: #67C23A;
    }
    .state1{
        color: #E6A23C;
    }
    .state11{
        color: #F56C6C;
        .el-icon-info{
            color: #C0C4CC;
        }
    }
    .state3{
        color: #909399;
    }
    .state0{
        color: #606266;
    }
    .state10{
        color: #409EFF;
    }
    .state31{
        color: #909399;
    }
    .imageText{
        display: flex;
        // @include flexBox(flex-start);
        img{
            width: 106px;
            height: 60px;
        }
        .imageText-summary{
            margin-left: 5px;
            .textBox{
                width: 345px;
                height: 40px;
                line-height: 20px;
                overflow: hidden;
                .text{
                    float: right;
                    /* "margin-left"要等于".wrap::before"的宽度 */
                    margin-left: -10px;
                    width: 340px;
                    word-break: break-all;
                    // font-size: 0.48rem;
                }
                &::before {
                    float: left;
                    content: '';
                    width: 10px;
                    height: 100%;
                }
                &::after {
                    float: right;
                    content: "...";
                    /* 行高与".wrap"设置的一致即可 */
                    height: 40px;
                    line-height: 20px;
                    /* 设置三个省略号的宽度,大于字体文本宽度即可,数值随意。并使盒子不占位置 */
                    width: 37px;
                    margin-left: -30px;
                    /* 移动省略号位置 */
                    position: relative;
                    left: 96%;
                    bottom: 20px;
                    font-weight: 600;
                    padding-right: 1px;
                    background: #fff;
                    transition: all 0.5s;
                }
                .recommon{
                    color: #fff;
                    background: #E6A23C;
                    display: inline-block;
                    width: 36px;
                    height: 16px;
                    line-height: 16px;
                    text-align: center;
                    margin-right: 5px;
                    font-size: 12px;
                }
            }
            .price{
                margin-left: 5px;
                color: #F56C6C;
            }
        }
    }
    .paging{
        margin-top: 24px;
        @include flexBox(center);
    }
    .el-table__row:hover{
        .textBox{
            &::after{
                background: #F5F7FA;
            }
        }
    }
    .cell{
        padding-right: 0;
    }
}
</style>